import React from "react";
import PropTypes from "prop-types";
import LinearProgress from "@material-ui/core/LinearProgress";
import { connect } from "react-redux";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

import { fetchCharge } from "../../actions/charge";
import {
  resetRedirection,
  resetRedirectionParams
} from "../../actions/redirect";
import { Status } from "../../model/Charge";
import PaymentForm from "../../components/payment/PaymentForm";
import PaymentResult from "../../components/payment/result/PaymentResult";
import "../payment/PaymentPage.css";

export class VposPaymentPage extends React.Component {
  static closeIframe() {
    const event = { type: "lpg.iframe.close" };
    window.parent.postMessage(event, "*");
  }

  constructor(props) {
    super(props);
    this.getAttValueFromTheme = this.getAttValueFromTheme.bind(this);
  }

  componentDidMount() {
    const { match, dispatch, history } = this.props;
    const { params } = match;
    // alert(JSON.stringify(params));
    dispatch(fetchCharge(params.id));
    window.addEventListener("message", event => {
      const { data } = event;
      if (data && data.type && data.type === "lpg.iframe.close") {
        dispatch(resetRedirectionParams());
        dispatch(resetRedirection());
        dispatch(fetchCharge(params.id));
        history.push(`/charge/${params.id}`);
      }
    });
  }

  getAttValueFromTheme(currentValue, firstAttribute, secondAttribute) {
    const { charge } = this.props;
    const { theme } = charge;
    return theme &&
      theme.palette &&
      theme.palette[firstAttribute] &&
      theme.palette[firstAttribute][secondAttribute]
      ? theme.palette[firstAttribute][secondAttribute]
      : currentValue;
  }

  render() {
    const { error, isLoading, charge, match } = this.props;
    if (error) {
      return <span>{error}</span>;
    }

    const theme = createMuiTheme({
      typography: {
        fontSize: 16
      },
      palette: {
        primary: {
          light: `${this.getAttValueFromTheme("#29337A", "primary", "light")}`,
          main: `${this.getAttValueFromTheme("#20285f", "primary", "main")}`,
          dark: `${this.getAttValueFromTheme("#171C43", "primary", "dark")}`
        },
        secondary: {
          main: `${this.getAttValueFromTheme("#3775ba", "secondary", "main")}`
        },
        error: {
          main: `${this.getAttValueFromTheme("#db504a", "error", "main")}`
        },
        background: {
          default: `${this.getAttValueFromTheme(
            "#ecebe4",
            "background",
            "default"
          )}`,
          paper: `${this.getAttValueFromTheme("#fff", "background", "paper")}`
        },
        text: {
          primary: `${this.getAttValueFromTheme(
            "rgba(0, 0, 0, 0.87)",
            "text",
            "primary"
          )}`,
          secondary: `${this.getAttValueFromTheme(
            "rgba(0, 0, 0, 0.54)",
            "text",
            "secondary"
          )}`
        }
      }
    });

    let componentToDisplay;
    const vpos = true;
    switch (charge.status) {
      case Status.PAID:
      case Status.DROPPED:
      case Status.DOUBLE_SPEND:
      case Status.LATE_SPEND:
      case Status.REFUNDED:
      case Status.REFUNDED_PARTIALLY:
        componentToDisplay = <PaymentResult charge={charge} />;
        break;
      case Status.DUE:
      case Status.RUNNING:
        componentToDisplay = (
          <PaymentForm charge={charge} match={match} isVpos={vpos} />
        );
        break;
      default:
        componentToDisplay = <span>Error: charge state is unknown</span>;
        break;
    }

    return (
      <MuiThemeProvider theme={theme}>
        <Paper id="payment-page">
          {isLoading ? <LinearProgress /> : componentToDisplay}
          {window.location !== window.parent.location && (
            <button
              id="lpg-modal-close"
              type="button"
              onClick={VposPaymentPage.closeIframe}
            >
              ×
            </button>
          )}
        </Paper>
      </MuiThemeProvider>
    );
  }
}

VposPaymentPage.propTypes = {
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  charge: PropTypes.shape({
    status: PropTypes.string,
    theme: PropTypes.shape()
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    })
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  dispatch: PropTypes.func.isRequired
};

VposPaymentPage.defaultProps = {
  isLoading: true,
  error: undefined,
  charge: {}
};

function mapStateToProps({ chargeReducer }) {
  return chargeReducer;
}

export default connect(mapStateToProps)(VposPaymentPage);
